import { render } from "./BoxUser.vue?vue&type=template&id=e64fb04e&scoped=true&ts=true"
import script from "./BoxUser.vue?vue&type=script&lang=ts"
export * from "./BoxUser.vue?vue&type=script&lang=ts"

import "./BoxUser.vue?vue&type=style&index=0&id=e64fb04e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e64fb04e"]])

export default __exports__